
  if (!customElements.get('tabbed-info-component')) {

    class TabbedInfoComponent extends HTMLElement {

      connectedCallback() {

        if (this.dataset.initialized === 'true') {
          return;
        }

        this.dataset.initialized = 'true';

        this.tabList =
          this.querySelector('.tabbed-info__tablist');

        this.panelContainer =
          this.querySelector('.tabbed-info__panels');

        this.blockContainer =
          this.querySelector('.tabbed-info__blocks');


        this.setupTabs();

      }


      setupTabs() {

        const tabWrappers =
          this.blockContainer.querySelectorAll(
            '.tabbed-info__tab-wrapper'
          );


        tabWrappers.forEach((wrapper, index) => {

          const button =
            wrapper.querySelector(
              '[data-tab-index]'
            );

          const panel =
            wrapper.querySelector(
              '[data-panel-index]'
            );


          if (!button || !panel) {
            return;
          }


          /*
            Move button into the tab list
          */

          this.tabList.appendChild(button);

           /*
    First tab specific class
  */

  if (index === 0) {
    panel.classList.add(
      'tabbed-info__panel--first'
    );
  }

          /*
            Move panel into the panel container
          */

          this.panelContainer.appendChild(panel);


          /*
            Remove now-empty wrapper
          */

          wrapper.remove();


          /*
            First tab active
          */

          if (index === 0) {

            button.classList.add(
              'tabbed-info__tab--active'
            );

            button.setAttribute(
              'aria-selected',
              'true'
            );

            panel.hidden = false;

            panel.classList.add(
              'tabbed-info__panel--active'
            );

          } else {

            button.setAttribute(
              'aria-selected',
              'false'
            );

            panel.hidden = true;

          }


          /*
            Click event
          */

          button.addEventListener(
            'click',
            () => {

              this.showTab(
                button.dataset.tabIndex
              );

            }
          );

        });


        /*
          Hide temporary container
        */

        this.blockContainer.remove();

      }


      showTab(index) {

        const tabs =
          this.tabList.querySelectorAll(
            '[data-tab-index]'
          );


        const panels =
          this.panelContainer.querySelectorAll(
            '[data-panel-index]'
          );


        tabs.forEach((tab) => {

          const active =
            tab.dataset.tabIndex === index;

          tab.classList.toggle(
            'tabbed-info__tab--active',
            active
          );

          tab.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );

        });


        panels.forEach((panel) => {

          const active =
            panel.dataset.panelIndex === index;

          panel.classList.toggle(
            'tabbed-info__panel--active',
            active
          );

          panel.hidden = !active;

        });

      }

    }


    customElements.define(
      'tabbed-info-component',
      TabbedInfoComponent
    );

  }


